module.exports = __webpack_public_path__ + "img/69_37.d19c932b.png";